

 
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';  
import { HttpParams } from '@angular/common/http';
 
export interface CollectionReport {
        patientName: String,
        regNum: String,
        billDate: Date,
        billNumber: String,
        billType :any;
        totalAmount: any,
        tax: any,
        discountValue:any,
        netValue: any,
        cash: any,
        card: any,
        cheque: any,
        upi:any,
        dd: any,
        insurance: any,
        credit: any,
        location: string,
        departmentName: string,
        physicianName: string
}
 
export abstract class CollectionReportData { 
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: any): any; 
    abstract searchList(url: string,data:any): Observable<any>;
    abstract list(url: string,queryParams?:HttpParams): Observable<any>;
}